module.exports = __webpack_public_path__ + "static/media/submitted.55c02cc3.png";